module.exports = __webpack_public_path__ + "static/media/board.5d412ab1.png";